"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Counter_1 = require("./Counter");
exports.default = Counter_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Counter/index.js
// module id = 935
// module chunks = 8